module.exports = __webpack_public_path__ + "img/explainer-13.6ce90e52.jpg";